/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */
import React, { useEffect, useState, Fragment } from "react";
import PropTypes from "prop-types";
import { V3Footer, V3Header, AnnouncementMd } from "hds-web";
// import CookiesPrompt from "./common/cookiesprompt";
// import { ThinStripBanner } from "./ThinStripBanner";

// import EventsSection from "./homepagenew/eventssection";

function urlParam(url) {
  const defaultString = "home";
  const remainingPart = url.replace(/^(https:\/\/hasura.io\/)/, "");
  const customString = remainingPart.replace(/^\/+/, "").replace(/\//g, "-");
  if (customString === "") {
    return defaultString;
  }
  return customString;
}

const Layout = props => {
  const { children, location } = props;

  const path = location.pathname;

  const isRmoveFooter =
    path === "/learn/" || path === "/graphql/" || path?.startsWith("/enterprisegraphql/")
      ? true
      : false;

  const isCareersPage = path === "/careers" || path === "/careers/";

  // const isRemoveAnnouncenent =
  //   path === "/graphql/" ||
  //   path?.startsWith("/data-api-days/") ||
  //   path?.startsWith("/events/deliver-applications-and-apis-faster-with-snowflake-and-hasura")
  //     ? true
  //     : false;

  const isRemoveAnnouncenent = true;

  const [windowScrollPosition, updateWindowScrollPosition] = useState(null);

  const [websiteKey, setWebsiteKey] = useState("");

  useEffect(() => {
    const currentUrl = window.location.href;
    const website_key = urlParam(currentUrl);
    setWebsiteKey(website_key);

    const handleScroll = () => {
      const currentScrollPosition = window.pageYOffset;

      updateWindowScrollPosition(currentScrollPosition);
    };

    window.addEventListener("scroll", handleScroll);

    handleScroll();

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const isBoxShadowActive = windowScrollPosition && windowScrollPosition > 60;

  return (
    <Fragment>
      {/* eslint-disable-next-line */}
      <div
        className={isCareersPage ? "viewport viewport-careers" : "viewport"}
        // className="viewport"
        // eslint-disable-next-line
        id="layoutContentWrapper"
      >
        {/* <ThinStripBanner /> */}
        {!isRemoveAnnouncenent && (
          <div className="bg-neutral-0 px-4 db:px-6">
            <AnnouncementMd
              // brandImg="https://res.cloudinary.com/dh8fp23nd/image/upload/v1689691893/hasura-con-2023/hasuracon-icon_m7tinx.svg"
              // brandAlt="Hasuracon 2024"
              linkText="AI Disrupt: An exclusive AI leadership summit. Register Now"
              textClass="text-neutral-0"
              // linkText="The HasuraCon 2024 CFP is open! Submit your talk"
              linkUrl="https://hasura.io/events/ai-disrupt"
              // linkUrl="https://hasura.io/events/community-call/2024/feb"
              // tagColor= 'purple'
              bgColorClass="bg-neutral-0"
            />
          </div>
        )}
        <div className="flex flex-col">
          {/* {!withoutHeader && <Header location={location} />} */}
          {!props?.withoutHeader && (
            <div className="sticky top-0 z-[1000000]">
              <div
                className={
                  "bg-neutral-0 " +
                  (isBoxShadowActive ? " shadow " : " border-b border-neutral-200 tb-l:shadow-none")
                }
              >
                <div className="px-4">
                  <div
                    className={`transition-all duration-300 ease-in-out ${
                      isBoxShadowActive ? "py-0" : "tb-l:py-3"
                    }`}
                  >
                    <div className="max-w-7xl  mx-auto">
                      <V3Header
                        hideLoginButton
                        website_key={websiteKey}
                        ALGOLIA_APP_ID={process.env.GATSBY_ALGOLIA_APP_ID}
                        ALGOLIA_SEARCH_KEY={process.env.GATSBY_ALGOLIA_SEARCH_KEY}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
          <div className="wd100">{children}</div>
          {/*!hideEventPath ? <EventsSection hideEventPath = {hideEventPath}/> : null*/}
          {/* {!isRmoveFooter && <Footer location={location} />} */}
          {!isRmoveFooter && (
            <div className="w-full float-left clear-both">
              <div className="pt-10 tb:pt16 db:pt-20">
                <div className="px-4">
                  <div className="mx-auto max-w-[1280px] pb-10 tb:pb-16">
                    <div className="w-full">
                      <div className="interFont">
                        {/* <CookiesPrompt /> */}
                        <V3Footer />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </Fragment>
  );
};

Layout.propTypes = {
  children: PropTypes.node.isRequired,
  location: PropTypes.object,
};

export default Layout;
